module.exports = __webpack_public_path__ + "img/jzy_problem_03.57eb2360.png";